/*
 * Copyright (c) 2024. Dave van Rijn Development
 */

import './style/button.scss';

import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import {convertColor, editColor, ThemeShape} from "../../..";
import {isNotNull, isNull} from "../util/controlUtil";

interface Props {
    onClick: any;
    onMouseEnter: any;
    onMouseLeave: any;
    onMouseDown: any;
    label: string;
    containerClass: string;
    labelClass: string;
    id: string;
    padding: 'small' | 'normal' | 'large';
    disabled: boolean;
    withRipple: boolean;
    isHovered: boolean;
    baseColor: string;
    textColor: string;
    contextStyle: ThemeShape;
    title?: string;
    tabIndex?: number;
}

export class Button extends React.Component<PropsWithChildren<Props>> {
    getContainerClass = (): string => {
        const {disabled, withRipple, padding, containerClass} = this.props,
            classes = ['buttonController'];
        if (disabled) classes.push('disabled');
        else if (withRipple) classes.push('ripple');

        if (padding === 'small') classes.push('sp');
        else if (padding === 'large') classes.push('lp');

        classes.push(containerClass);
        return classNames(classes);
    };

    getContainerStyle = (): object => {
        const {isHovered, baseColor} = this.props;
        let hexColor = convertColor(baseColor);
        if (isHovered) hexColor = editColor(-.2, hexColor);
        return {backgroundColor: hexColor};
    };

    getLabelStyle = (): object => {
        const {textColor} = this.props;
        return {color: convertColor(textColor)};
    };

    getRippleColor = (): string => {
        const {contextStyle, textColor} = this.props;
        if(textColor) return convertColor(textColor);
        return convertColor(contextStyle.contrastColor);
    };

    renderLabel = (): React.ReactNode => {
        const {children, labelClass, label} = this.props, leftElements = [], rightElements = [];
        if (Array.isArray(children)) {
            for (let child of children) {
                if (child !== undefined && child !== null) {
                    //@ts-ignore
                    const {placement, element} = child;
                    if (placement === 'left') leftElements.push(element);
                    else rightElements.push(element);
                }
            }
        } else if (isNotNull(children)) {
            //@ts-ignore
            const {placement, element} = children;
            if (placement === 'left') leftElements.push(element);
            else rightElements.push(element);
        }
        return (
            <span className={classNames('buttonLabel', isNull(children) && 'singleChild', labelClass)}
                  style={this.getLabelStyle()}>
                {leftElements.map((element, key) => ({...element, key}))}
                {isNotNull(label) && <span className='buttonLabel'>{label}</span>}
                {rightElements.map((element, key) => ({...element, key}))}
            </span>)
    };

    render = () => {
        const {onClick, onMouseEnter, onMouseLeave, id, onMouseDown, withRipple, title, tabIndex} = this.props,
            titleProps = isNotNull(title) ? {title} : {};
        return (
            <div className={this.getContainerClass()} style={this.getContainerStyle()} onClick={onClick}
                 onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} onMouseDown={onMouseDown}
                 id={id} tabIndex={tabIndex} {...titleProps}>
                {this.renderLabel()}
                {withRipple && <div className='ripple' style={{backgroundColor: this.getRippleColor()}}/>}
            </div>
        )
    };
}